export const confidenceLevels = {
    notConfident: {
        title: "Not Confident",
        icon: "tired",
        colorCode: "red.500"
    },
    aLittleConfident: {
        title: "A Little Confident",
        icon: "frown",
        colorCode: "yellow.500"
    },
    somewhatConfident: {
        title: "Somewhat Confident",
        icon: "smile",
        colorCode: "blue.500"
    },
    veryConfident: {
        title: "Very Confident",
        icon: "grin",
        colorCode: "teal.500"
    },
    extremelyConfident: {
        title: "Extremely Confident",
        icon: "laugh",
        colorCode: "green.500"
    }
}